"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppSelector = void 0;
const react_redux_1 = require("react-redux");
const toolkit_1 = require("@reduxjs/toolkit");
const redux_logger_1 = __importDefault(require("redux-logger"));
const redux_thunk_1 = __importDefault(require("redux-thunk"));
const reducers_1 = __importDefault(require("./reducers"));
const isDev = process.env.NODE_ENV !== 'production';
const store = (0, toolkit_1.configureStore)({
    reducer: reducers_1.default,
    devTools: isDev,
    //@ts-ignore
    middleware: isDev ? [redux_thunk_1.default, redux_logger_1.default] : [redux_thunk_1.default]
});
exports.default = store;
exports.useAppSelector = react_redux_1.useSelector;
